import values from "./values";

class Strings {

    get(key) {
        return values[key];
    }
}

export default new Strings();